import React from 'react';
import { useOktaAuth } from '@okta/okta-react';
import Loader from '../Loader';
import { logSpaLandingEvent } from '../lib/amplitude-utils';
import config from '../lib/config';

export default function ManageProfile() {
  const { authState } = useOktaAuth();

  React.useEffect(() => {
    logSpaLandingEvent();
  }, []);

  if (!authState) return <Loader />;

  const params = new URL(window.location.href).searchParams;
  window.location.href = (params.get("code")) ?
    `${config.manageProfileAppUrl}?isPhr=true` : `${config.manageProfileAppUrl}`;
}
